module.exports = __webpack_public_path__ + "img/project-10.d732c8fd.jpg";